import React, { PureComponent } from 'react';
import logo from '../../../../resource/img/logo.png';
import Button from 'component/button.component';
import { Link as RouterLink, withRouter } from 'react-router-dom';

class AdminHeader extends PureComponent {
  render() {
    return (
      <div
        className="header-menu flex-row justify-center align-stretch"
        style={{
          height: 70,
          position: 'fixed',
          top: 0,
          width: '100%',
          zIndex: 10,
          backgroundColor: '#400',
        }}
      >
        <div className="content-center flex-row justify-between align-stretch">
          <div className="flex-row flex-1 align-stretch">
            <RouterLink
              className="header-menu-logo flex-row justify-start align-center"
              to="/"
            >
              <img className="header-menu-logo-img" src={logo} alt="logo" />
              <p className="header-menu-logo-text">Juslabore</p>
            </RouterLink>
            <div className="header-menu-center-content flex-column flex-1 justify-center align-start">
              <div className="flex-row align-center justify-center">
                <Button
                  className="header-button"
                  onClick={() => this.props.history.push(`/admin/artigo`)}
                  text="Inserir Artigo"
                  style={{ width: 120 }}
                />
                <Button
                  className="header-button"
                  onClick={() => this.props.history.push(`/admin/listaArtigos`)}
                  text="Listar Artigos"
                  style={{ width: 120 }}
                />
                <Button
                  className="header-button"
                  onClick={() => this.props.history.push(`/admin/template`)}
                  text="Inserir Templates"
                  style={{ width: 120 }}
                />
                <Button
                  className="header-button"
                  onClick={() =>
                    this.props.history.push(`/admin/listaTemplates`)
                  }
                  text="Listar Templates"
                  style={{ width: 120 }}
                />
                <Button
                  className="header-button"
                  onClick={() =>
                    this.props.history.push(`/admin/acompanhar-agenda`)
                  }
                  text="Acompanhar Agenda"
                  style={{ width: 120 }}
                />
              </div>
            </div>
          </div>
          <div className="flex-row align-center justify-center">
            <Button
              onClick={() => this.props.history.push(`/`)}
              text="Retornar"
              style={{ border: '2px solid #FFF', marginRight: 10 }}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(AdminHeader);
